import React, { useState, useEffect } from 'react';
import { Box } from '@mui/system';
import Template from '@/components/dynamicComponent/Template';
import PageHeader from '@/components/PageHeader';
import { fieldGenerator } from '@/lib/dynamicTable';
import moment from 'moment';
import { Typography } from '@mui/material';
import { Image, Upload, Button } from 'antd';
import client from '@/lib/feathers';
import axios from 'axios';
import { Message } from '@alifd/next';

const CommitteeStructurePicture = () => {
  const [picture, setPicture] = useState({});
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const fetchPicture = async () => {
      const responsePicture = (await client.service('communityData').find({}))
        .data[0].CommitteeStructurePicture;
      setPicture(responsePicture[0]);
    };
    fetchPicture();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '20px',
      }}
    >
      <Typography variant="subtitle1">組織架構圖</Typography>
      {picture?.showPath && (
        <Image
          src={`${location.origin}${picture.showPath}`}
          width={300}
          style={{
            width: '300px',
            maxHeight: '300px',
          }}
          preview={{
            visible,
            onVisibleChange: (val) => setVisible(val),
            src: picture.url,
          }}
        />
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '10px',
        }}
      >
        <Upload
          customRequest={async (options) => {
            const { file, onSuccess, onError } = options;
            if (file) {
              const formData = new FormData();
              formData.append('files', file);
              try {
                const res = await axios.post(
                  '/newUploads?type=communityData',
                  formData,
                  {
                    headers: {
                      authorization: localStorage.getItem('feathers-jwt'),
                    },
                  }
                );
                onSuccess(res.data);
              } catch (e) {
                onError(e, null);
              }
            }
          }}
          accept="image/*"
          onChange={async ({ file }) => {
            switch (file.status) {
              default:
                break;
              case 'uploading':
                Message.loading({ content: '上傳中...', duration: 0 });
                break;
              case 'done':
                Message.success({ content: '上傳成功' });
                await client
                  .service('communityData')
                  .patch(
                    null,
                    { CommitteeStructurePicture: file.response },
                    {}
                  );
                setPicture(file.response);
                break;
              case 'error':
                Message.error({ content: '上傳失敗' });
                break;
            }
          }}
          showUploadList={false}
        >
          <Button>上傳架構圖</Button>
        </Upload>
        <Button
          danger
          onClick={async () => {
            try {
              await client.service('uploads').remove(picture._id);
              await client
                .service('communityData')
                .patch(null, { CommitteeStructurePicture: {} }, {});
              Message.success({ content: '刪除成功' });
              setPicture({});
            } catch (e) {
              Message.error({ content: '刪除失敗' });
              console.error(e);
            }
          }}
        >
          移除架構圖
        </Button>
      </Box>
    </Box>
  );
};

const dynamicStructure = {
  // Table 管委會名單
  dbName: 'menuCommunityAdmin',
  text: '歷屆管委會名單',
  funcs: [{ name: 'createData', text: '新增人員', type: 'EditButton' }],
  fields: {
    // 各欄位的資料型態
    job: fieldGenerator('job', '職務名稱'),
    name: fieldGenerator('name', '姓名'),
    inCharge: fieldGenerator('inCharge', '職掌內容'),
    phone: fieldGenerator('phone', '電話'),
    createTime: fieldGenerator(
      'createTime',
      '建立時間',
      'hidden',
      {},
      {},
      { width: 200, cell: (val) => moment(val).format('YYYY-MM-DD HH:mm:ss') }
    ),
  },
  manipulate: [
    { name: 'editData', text: '編輯', type: 'EditButton' },
    { name: 'deleteData', text: '刪除', type: 'DeleteButton' },
  ],
};

export default function ManagementCommittee({ showHeader = true }) {
  return (
    <Box>
      {/* header */}
      {showHeader && (
        <PageHeader
          title="歷屆管委會名單"
          breadcrumbs={[{ name: '組織管理' }, { name: '歷屆管委會名單' }]}
        />
      )}
      <CommitteeStructurePicture />
      <Typography variant="subtitle1" gutterBottom>
        組織管理
      </Typography>
      <Template {...{ dynamicStructure }} />
    </Box>
  );
}
